import React from 'react';
import PT from 'prop-types';

import Block from '../Block';
import Text from '../Text';

const TextBlock = ({ data }) => (
  <Block>
    <Text html={data.value.body} />
  </Block>
);

TextBlock.propTypes = {
  data: PT.object,
};

export default TextBlock;
